import { Button } from "@/shared/components/base-button";
import IconLogoPacifico from "@/assets/images/iconLogoPacifico";
import Login from "@/assets/images/login";

import { loginRequestScope } from "../../../../../constants/msal";
import { useAuth } from "@/context/AuthContext";
import { clearSesionStorage } from "@/utils/storage";

export const LoginMsal = () => {

  const { login } = useAuth();
  const handleLogin = () => {
    clearSesionStorage();
    login(loginRequestScope || []);
  };

  return (
    <div className="w-screen min-h-screen bg-gradient-to-r from-surface-light-blue to-purple-light-blue flex items-center justify-center p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-[80px] w-full">
        {/* Columna 1 - Imagen (arriba en mobile) */}
        <div className="flex justify-center order-first md:order-last pr-0 md:pr-[61px]">
          <div className="flex items-center justify-center w-full md:w-auto">
            <Login className="w-full h-auto max-w-sm md:max-w-2xl" />
          </div>
        </div>

        {/* Columna 2 - Contenido de Login (abajo en mobile) */}
        <div className="flex justify-center order-last md:order-first w-full">
          <div className="flex flex-col justify-center w-[322px]">
            <IconLogoPacifico />
            <p className="text-base font-normal text-gray-700 mt-[8px]">
              Te damos la bienvenida a la nueva plataforma digital de seguro de
              desgravamen.
            </p>
            
            <Button
              appearance="primary"
              widthVariant="full"
              className="mt-[50px] w-[230px] h-[44px] rounded-[40px] mx-auto"
              onClick={handleLogin}
            >
              Ingresar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
